module.exports = __webpack_public_path__ + "media/images/logo-6-e75344a331e7f7a2985206724098e398.png";